import { render, staticRenderFns } from "./crudTasks.vue?vue&type=template&id=5395054d&"
import script from "./crudTasks.vue?vue&type=script&lang=js&"
export * from "./crudTasks.vue?vue&type=script&lang=js&"
import style0 from "./crudTasks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports